export const youtubeVideoIDParser = (url: string): string => {
  const regExpGetVideoID = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
  const match = url.match(regExpGetVideoID)

  return match && match[1].length == 11 ? match[1] : url
}
